import React, { useState, useEffect } from "react";
import axios from "axios";
import TextField from "@mui/material/TextField";
import Skeleton from "@mui/material/Skeleton";
import CircularProgress from "@mui/material/CircularProgress";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
//
import { validate } from "../../login/validate";
// componets
import AlertSuccess from "../../../components/AlertSuccess/AlertSuccess";
// config
import configData from "../../../config/config.json";

const InfoPage = (props) => {
  const { apiInfoData, infoApiCome } = props;
  // btn disable
  const [disable, setDisable] = useState(false);
  // info data
  const [infoData, setInfoData] = useState({
    fname: "",
    lname: "",
    email: "",
    username: "",
  });
  const infoInputHandler = (event) => {
    setInfoData({ ...infoData, [event.target.name]: event.target.value });
    if (event.target.name == "username") {
      setUsernameLoading("");
      setUsernameCheckError("");
      setDisable(true);
    }
  };

  //   for success alert
  const [showAlert, setshowAlert] = useState(false);
  const alertHandeler = () => {
    setshowAlert(true);
    setTimeout(() => {
      // After 3 seconds set the show value to false
      setshowAlert(false);
    }, 4000);
  };

  // for validation error
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  useEffect(() => {
    setErrors(validate(infoData, "business-setting-info"));
  }, [infoData, touched]);

  const [apiError, setApiError] = useState([]);
  const [apiErrorSubmit, setApiErrorSubmit] = useState([]);

  // username check
  const [usernameLoading, setUsernameLoading] = useState("");
  const [usernameCheckError, setUsernameCheckError] = useState("");
  const usernameCheck = () => {
    if (infoData.username !== "") {
      setUsernameCheckError("");
      setUsernameLoading("spinner");
      setDisable(true);

      var username = infoData.username;
      axios
        .get(
          configData.API_DOMAIN +
            "/api/v1/BusinessOwners/exists-username/" +
            username,
          {
            headers: header,
          }
        )
        .then((response) => {
          if (response.data.isSuccess) {
            if (!response.data.data) {
              setUsernameLoading("done");
              setDisable(false);
            } else {
              setUsernameCheckError(
                "این نام کاربری قبلا در گیشنیز ثبت شده است."
              );
              setUsernameLoading("");
              setDisable(false);
            }
          } else {
            setUsernameLoading("");
            setDisable(false);
            setApiError(response.data.message);
          }
        })
        .catch((error) => {
          // alert(error);
        });
    }
  };

  //api header
  const header = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    Authorization: "Bearer " + getCookie("token"),
  };

  useEffect(() => {
    if (infoApiCome) {
      setInfoData({
        fname: apiInfoData.firstname,
        lname: apiInfoData.lastname,
        email: apiInfoData.email,
        username: apiInfoData.username,
      });
    }
  }, [infoApiCome]);

  //   submit btn
  const submitHandler = (event) => {
    event.preventDefault();
    setApiErrorSubmit([]);

    if (!Object.keys(errors).length) {
      setDisable(true);

      const dataPost = {
        firstname: infoData.fname,
        lastname: infoData.lname,
        email: infoData.email,
        username: infoData.username,
      };

      axios
        .patch(configData.API_DOMAIN + "/api/v1/BusinessOwners", dataPost, {
          headers: header,
        })
        .then((response) => {
          setDisable(false);
          if (response.data.isSuccess) {
            // success
            delete errors.email;
            alertHandeler();
          } else {
            setApiErrorSubmit(response.data.message);
          }
        })
        .catch((error) => {
          alert(error);
        });
    } else {
      setTouched({
        email: true,
        username: true,
        fname: true,
        lname: true,
      });
    }
  };

  //   getCookie
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  return (
    <>
      <div className="dash-setting-body">
        <h6>اطلاعات حساب کسب‌وکار</h6>
        <p>اطلاعات اولیه خود را بنویسید</p>
        <div className="d-md-flex mb-2">
          <div className="w-100 ">
            <p className="dash-setting-input-tit mt-md-0 mt-2">نام</p>
            {infoApiCome ? (
              <TextField
                type="text"
                value={infoData.fname}
                onChange={infoInputHandler}
                name="fname"
                id="outlined-basic"
                // label="English buisness name"
                variant="outlined"
                className={
                  errors.fname && touched.fname
                    ? " custom-text-field width-100 mb-2 font-family-en custom-text-field-border-error"
                    : " custom-text-field width-100 mb-2 font-family-en"
                }
              />
            ) : (
              <Skeleton
                className="mt-n2"
                height={56}
                variant="text"
                animation="wave"
              />
            )}
            {errors.fname && touched.fname && (
              <span className="input-error mx-0 mt-n1">{errors.fname}</span>
            )}
          </div>
          <div className="w-100 me-md-3">
            <p className="dash-setting-input-tit mt-md-0 mt-2">نام خانوادگی</p>
            {infoApiCome ? (
              <TextField
                type="text"
                value={infoData.lname}
                onChange={infoInputHandler}
                name="lname"
                id="outlined-basic"
                // label="English buisness name"
                variant="outlined"
                className={
                  errors.lname && touched.lname
                    ? " custom-text-field width-100 mb-2 font-family-en custom-text-field-border-error"
                    : " custom-text-field width-100 mb-2 font-family-en"
                }
              />
            ) : (
              <Skeleton
                className="mt-n2"
                height={56}
                variant="text"
                animation="wave"
              />
            )}
            {errors.lname && touched.lname && (
              <span className="input-error mx-0 mt-n1">{errors.lname}</span>
            )}{" "}
          </div>
        </div>
        <div className="d-md-flex mb-2">
          <div className="w-100 ">
            <p className="dash-setting-input-tit mt-md-0 mt-2">ایمیل</p>
            {infoApiCome ? (
              <>
                <TextField
                  disabled
                  dir="ltr"
                  type="email"
                  value={infoData.email}
                  onChange={infoInputHandler}
                  name="email"
                  id="outlined-basic"
                  // label="English buisness name"
                  variant="outlined"
                  className={
                    errors.email && touched.email
                      ? " custom-text-field width-100 mb-2 font-family-en custom-text-field-border-error"
                      : " custom-text-field width-100 mb-2 font-family-en"
                  }
                />
                {errors.email && touched.email && (
                  <span className="input-error mx-0 mt-n1">{errors.email}</span>
                )}
              </>
            ) : (
              <Skeleton
                className="mt-n2"
                height={56}
                variant="text"
                animation="wave"
              />
            )}
          </div>
          <div className="w-100 me-md-3 position-relative">
            <p className="dash-setting-input-tit mt-md-0 mt-2">نام کاربری</p>
            {infoApiCome ? (
              <TextField
                type="text"
                value={infoData.username}
                onChange={infoInputHandler}
                onBlur={usernameCheck}
                name="username"
                id="outlined-basic"
                // label="English buisness name"
                variant="outlined"
                className={
                  usernameCheckError || (errors.username && touched.username)
                    ? " custom-text-field width-100 mb-2 font-family-en custom-text-field-border-error"
                    : " custom-text-field width-100 mb-2 font-family-en"
                }
              />
            ) : (
              <Skeleton
                className="mt-n2"
                height={56}
                variant="text"
                animation="wave"
              />
            )}
            {usernameCheckError !== "" && (
              <span className="input-error mx-0 mt-n1">
                {usernameCheckError}
              </span>
            )}
            {usernameLoading == "done" ? (
              <CheckCircleIcon
                color="inherit"
                sx={{ fontSize: 20, color: "#33e0a0" }}
                className="setting-input-spinner"
              />
            ) : (
              ""
            )}
            {usernameLoading == "spinner" ? (
              <CircularProgress
                color="inherit"
                size={18}
                className="setting-input-spinner"
              />
            ) : (
              ""
            )}
            {errors.username && touched.username && (
              <span className="input-error mx-0 mt-n1">{errors.username}</span>
            )}
          </div>
        </div>

        {apiErrorSubmit.map((item) => (
          <span className="input-error mx-0">{item}</span>
        ))}

        <div className="text-center text-md-start mt-4 mb-3">
          {infoApiCome ? (
            <button
              onClick={submitHandler}
              disabled={disable}
              className="btn_input_business mb-5"
            >
              ذخیره
            </button>
          ) : (
            <Skeleton
              className="me-md-auto ms-md-0 mx-auto mb-5 mt-5"
              height={56}
              width={95}
              variant="text"
              animation="wave"
            />
          )}
        </div>
      </div>
      {/* alert delete */}
      <AlertSuccess
        showAlert={showAlert}
        text={" اطلاعات شما با موفقیت ثبت شد."}
      />
    </>
  );
};

export default InfoPage;
